import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AppointmentTable from "../components/AppointmentTable";
import { useParams } from "react-router-dom";
import ViewAppointmentLayer from "../components/ViewAppointmentLayer";
import ViewStockLayer from "../components/ViewStockLayer";
import { API_URL } from "..";

const ViewStockPage = () => {
    const [data,setData]= useState({})
    const {id} = useParams();
    const fetchAppointments = async () => {
        let headerList = {
          "Accept": "*/*",
          "Content-type": "application/json",
        };
        const response = await fetch(
          API_URL+`/api/invoice/stock/fetch-single/${id}`,
          { method: "GET", headers: headerList }
        );
        const data = await response.json();
        if (response.status === 200) {
            setData(data.stock)
        }
      };

      useEffect(()=>{
        fetchAppointments()
      },[1])
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="View Stock" />
        {
            data.title === undefined ? 
            null:
            <ViewStockLayer data={data}/>
        }
        
      </MasterLayout>

    </>
  );
};

export default ViewStockPage; 
